export interface NavigationState {
    workstockCounter: number | undefined;
    loadingWorkstockCounter: boolean;
    dwsmCounter: number | undefined;
    loadingDWSMCounter: boolean;
    favoriteCounter: number | undefined;
}

export const initialState: NavigationState = {
    workstockCounter: undefined,
    loadingWorkstockCounter: false,
    dwsmCounter: undefined,
    loadingDWSMCounter: false,
    favoriteCounter: undefined
};

export const featureKey = 'navigationModule';
